<!-- QuizGrade.vue -->
<template>
    <article class="flex flex-col gap-5" id="quiz-grade">
        <h2 class="heading-02 font-semibold text-blue-default" v-html="quizPassed ? 'Congratulations!' : 'Try Again'"></h2>

        <p class="heading-03 flex items-center justify-start gap-7">
            <strong class="">Your Score:</strong>

            <strong
                :class="[quizPassed ? 'bg-green-1' : 'bg-red-2']"
                class="py-3 px-6 rounded-[10px]"
            >{{ percent }}/100</strong>
        </p>

        <div class="richtext richtext--lg" v-html="quizPassed ? coursePassedCopy : courseFailedCopy"></div>

        <div class="flex flex-wrap gap-3">
            <div class="inline-flex flex-col items-center gap-3" v-if="!quizPassed">
                <button class="button button--rounded button--large" @click="submitTryAgain">
                    Try Again
                </button>
                <a v-if="firstLessonUrl" :href="firstLessonUrl" class="underline text-xs font-semibold hover:no-underline">Start course over</a>
            </div>
            
            <div v-if="!quizPassed">
                <a href="#quiz-results" class="button button--rounded button--large button--outline">Show Me The Answers</a>
            </div>

            <div v-if="quizPassed && certificateUrl">
                <a :href="certificateUrl" class="button button--rounded button--large" target="_blank" rel="noopener noreferrer">
                    Download Certificate
                    <div v-html="PdfIcon" class="min-w-4 w-4 h-auto"></div>
                </a>
            </div>
        </div>
    </article>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import axios from 'axios';
    import PdfIcon from '@icons/icon-selector/pdf-icon.svg?raw';

    const token = ref(null);
    const emit = defineEmits(['reloadQuiz', 'setSubmitting']);

    const getToken = async () => {
        const response = await axios.get('/actions/blitz/csrf/token');
        token.value = response.data;
    };

    const props = defineProps({
        letterGrade: '',
        percent: '',
        quizPassed: '',
        certificateUrl: '',
        firstLessonUrl: '',
        quizId: null,
        userId: null,
        coursePassedCopy: '',
        courseFailedCopy: ''
    });

    const submitTryAgain = async () => {
        // Tell parent component we're starting a submission
        emit('setSubmitting', true);
        
        const params = {
            'quizId': props.quizId,
            'userId': props.userId,
            'CRAFT_CSRF_TOKEN': token.value
        };

        const endpoint = `/courses/retake-quiz`;
        const config = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': props.url,
                'X-CSRF-Token': ''
            }
        };

        try {
            const response = await axios.post(endpoint, params, config);
            const data = response.data;
            
            if (data.success === true) {
                // Emit event to parent component to reload
                emit('reloadQuiz');
                // No need to reset submitting state here as reloadQuiz will reset the parent component
            } else {
                // Reset submitting state if we're not reloading
                emit('setSubmitting', false);
            }
        } catch (error) {
            console.error('Error retaking quiz:', error);
            // Reset submitting state on error
            emit('setSubmitting', false);
        }
    }

    onMounted(async () => {
        await getToken();
    });
</script>
